import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { useAppData } from '../contexts/AppDataContext';
import MaveshiBrandLogo from './MaveshiBrandLogo';
import { isPublicAppPath } from '../utils/publicAppPaths';

const { Text } = Typography;

const AppInitializer = ({ children }) => {
    const { isAuthenticated, loading: authLoading } = useAuth();
    const { initialized, loading: dataLoading } = useAppData();
    const location = useLocation();
    const [showLoading, setShowLoading] = useState(true);

    const isPublicRoute = isPublicAppPath(location.pathname);

    useEffect(() => {
        if (isPublicRoute) {
            setShowLoading(false);
            return;
        }

        if (authLoading) {
            setShowLoading(true);
            return;
        }

        if (!isAuthenticated) {
            setShowLoading(false);
            return;
        }

        if (dataLoading || !initialized) {
            setShowLoading(true);
        } else {
            const timer = setTimeout(() => {
                setShowLoading(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [authLoading, isAuthenticated, initialized, dataLoading, isPublicRoute]);

    if (showLoading) {
        return (
            <div style={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'radial-gradient(circle at center, #0b3d20 0%, #051f10 100%)',
                zIndex: 9999,
                position: 'fixed',
                top: 0,
                left: 0,
                color: '#fff'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '32px',
                    animation: 'fadeIn 0.5s ease-in-out'
                }}>
                    <MaveshiBrandLogo size="xl" pulse />

                    <div style={{ textAlign: 'center' }}>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: 700,
                            margin: '0 0 12px 0',
                            fontFamily: "'Inter', sans-serif",
                            letterSpacing: '-0.5px',
                            color: '#fff'
                        }}>
                            Maveshi
                        </h1>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center' }}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 18, color: 'rgba(255,255,255,0.8)' }} spin />} />
                            <Text style={{ fontSize: '15px', color: 'rgba(255,255,255,0.65)', fontWeight: 400 }}>
                                Initializing workspace...
                            </Text>
                        </div>
                    </div>
                </div>

                <style>
                    {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(10px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
                </style>

                <div style={{
                    position: 'absolute',
                    bottom: '48px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <div style={{
                        height: '2px',
                        width: '40px',
                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                        marginBottom: '8px'
                    }} />
                    <Text style={{
                        color: 'rgba(255,255,255,0.35)',
                        fontSize: '11px',
                        fontWeight: 500,
                        letterSpacing: '1px',
                        textTransform: 'uppercase'
                    }}>
                        Secured by MaveshiWala
                    </Text>
                </div>
            </div>
        );
    }

    return children;
};

export default AppInitializer;
